import { Injectable } from '@angular/core';
import { CandidateSearchFilter } from './models/candidate-search-filter.model';

@Injectable({
    providedIn: 'root'
})
export class CandidateSearchService {
    createFilter(searchText: string): CandidateSearchFilter {
        const wordRegex = /^[a-zA-Z0-9.'@_-]+$/;
        const phoneRegex = /^[-()0-9]+$/;
        const tokens = searchText?.trim()?.split(/\s+/);

        if (tokens) {
            if (tokens.length === 1) {
                // single-token phone
                if (phoneRegex.test(tokens[0])) {
                    return {
                        phone: tokens[0] //,
                        //candidateId: tokens[0]
                    };
                }

                // token is first name, last name OR email
                if (wordRegex.test(tokens[0])) {
                    return { tokens };
                }
            }

            if (tokens.length > 1) {
                // token is multi-part phone
                if (tokens.every((token) => phoneRegex.test(token))) {
                    return {
                        phone: searchText
                    };
                }

                // tokens are chunks of first AND last names
                if (tokens.every((token) => wordRegex.test(token))) {
                    return { tokens };
                }
            }
        }

        return null;
    }

    createRecipientFilter(searchText: string): CandidateSearchFilter | null {
        if (typeof searchText !== 'string') {
            return null;
        }

        const trimmed = searchText?.trim();
        if (!trimmed) {
            return null;
        }

        const wordRegex = /^[a-zA-Z0-9.'@_-]+$/;
        const candidateIdRegex = /^\d+$/;
        const tokens = trimmed.split(/\s+/);

        const isAllNumeric = tokens.every((t) => candidateIdRegex.test(t));
        const isAllWord = tokens.every((t) => wordRegex.test(t));

        if (isAllNumeric) {
            // Numeric input → treat as candidate ID string
            return { candidateId: trimmed };
        }

        if (isAllWord) {
            // Word tokens → name-based search
            return { tokens };
        }

        return null;
    }
}
